import * as Yup from 'yup';
import capitalize from './capitalize';

Yup.setLocale({
  mixed: {
    required: ({ path }) => `${formatPath(path)} is required`,
    'notType': ({ path, type }) => `${formatPath(path)} must be a ${type}`,
  },
  number: {
    positive: ({ path }) => `${formatPath(path)} must be a positive number`,
  }
});

function formatPath(path?: string) {
  if (!path) {
    return 'Field';
  }

  const pathWithWhitespace = path.replace(/_/g, ' ').replace(/\./g, ' ');

  return capitalize(pathWithWhitespace);
}

export default Yup;
